import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ApiService } from 'src/app/core/api.service';
import { UserService } from 'src/app/core/user.service';
import { ErrCode, User } from 'src/app/shared/models';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-dialog-password-hint',
  templateUrl: './dialog-password-hint.component.html',
  styleUrls: ['./dialog-password-hint.component.scss']
})
export class DialogPasswordHintComponent implements OnInit {
  @Input() user: User;
  @Input() showPasswordHintDialog: boolean;
  @Output() showPasswordHintDialogChange = new EventEmitter<boolean>();
  public errcode: ErrCode;
  public passwordHintEnabled: boolean = false;
  public hint: string;
  public invalidPassHintErr: string = '';
  public showErrCode: boolean = false;

  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    if (this.user.has_password_hint != 0) this.passwordHintEnabled = true;
  }

  togglePWhint = (event: MatSlideToggleChange) => {
    this.passwordHintEnabled = event.checked;
    this.invalidPassHintErr = '';
    this.errcode = undefined;
    if (!this.passwordHintEnabled) this.hint = undefined;
  }

  getPasswordHint = (passHint: string) => {
    this.hint = passHint;
    this.invalidPassHintErr = '';
    this.errcode = undefined;
  }

  savePasswordHint = async () => {
    this.errcode = undefined;
    if (!this.hint && this.passwordHintEnabled) {
      this.errcode = new ErrCode(
        1201,
        'Correct the errors below, then try again.'
      );
      this.invalidPassHintErr = 'Enter a valid password hint.';
      return;
    }
    try {
      await this.apiService.execute('passwordhintupdate', {
        password_hint: this.hint
      });
      this.userService.refresh();
      const statusMessage = this.user.has_password_hint && this.passwordHintEnabled ? 'updated.' : this.passwordHintEnabled ? 'enabled.' : 'disabled.';
      this.snackbarService.showMessage('success', 'Password hint ' + statusMessage);
      this.closePasswordHintDialog();
    } catch (ex) {
      this.errcode = ErrCode.fromException(ex);
      if (!this.errcode.msg || this.errcode.msg === 'An unknown error occurred') {
        this.closePasswordHintDialog();
        this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
      }
    }
  }

  closePasswordHintDialog = () => {
    this.showPasswordHintDialog = false;
    setTimeout(() => {
      this.showPasswordHintDialogChange.next(false);
    });
  }
}
